import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f440a5b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highscore-display" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "best" }, "Best", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.hasHighscore)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(_ctx.extraPointsClasses)
        }, [
          _createTextVNode(_toDisplayString(_ctx.currentHighscore), 1),
          (_ctx.isTimeScore)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "s"))
            : _createCommentVNode("", true)
        ], 2))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, "-"))
  ]))
}